<template>
    <transition name="advise-fade">
        <div v-if="show" class="mobile-advise">
            <CloseButton class="mobile-advise__close" @click="click" />
            <div class="mobile-advise__row mobile-advise__row--text">
                <RsvButton class="mobile-advise__logo" />
                <div>Все проекты в одном кармане.<br />Скачай приложение РСВ:</div>
            </div>
            <div class="mobile-advise__row mobile-advise__row--buttons">
                <AppStoreButton />
                <RuStoreButton />
            </div>
        </div>
    </transition>
</template>

<script>
import CloseButton from '@/components/UI/buttons/CloseButton.vue';
import AppStoreButton from '@/components/UI/buttons/MobileApps/AppStoreButton.vue';
import RuStoreButton from '@/components/UI/buttons/MobileApps/RuStoreButton.vue';
import RsvButton from '@/components/UI/buttons/RsvButton.vue';
import { getCachedValue, setCachedValue } from '@/tools/cache';

export default {
    components: {
        CloseButton,
        AppStoreButton,
        RuStoreButton,
        RsvButton,
    },
    data: () => ({
        cacheKey: 'advise-mobile-promotion-closed',
        show: false,
    }),
    mounted() {
        this.show = !getCachedValue(this.cacheKey);
    },
    methods: {
        click() {
            setCachedValue(this.cacheKey, true);
            this.show = false;
        },
    },
};
</script>

<style scoped lang="scss">
@import '@/styles/rem';
@import '@/styles/variables';

.mobile-advise {
    position: fixed;
    z-index: 120;
    bottom: 0;
    left: 0;
    right: 0;
    background: $color-secondary-violet-light;
    padding: urem(20);

    @include on-desktop {
        display: flex;
        flex-direction: column;
        gap: urem(23);
        position: relative;

        border-radius: urem(20);
        margin-bottom: 15px;

        font-size: urem(14);
        font-weight: 500;
        line-height: urem(20);
        padding: urem(20) urem(80) urem(20) urem(20);

        box-shadow: 0 urem(5) urem(16) rgba(70, 99, 171, 0.2);
    }

    &__logo {
        :deep(svg) {
            height: urem(45);
            width: auto;
        }
    }

    &__row {
        display: flex;
        align-items: center;
        flex-direction: row;
        gap: urem(14);

        &--text {
            @include on-mobile {
                display: none;
            }
        }

        &--buttons {
            gap: urem(40);

            @include on-mobile {
                justify-content: center;
            }

            :deep(svg) {
                height: urem(28);
                width: auto;
            }
        }
    }

    &__close {
        position: absolute;
        height: urem(12);
        width: auto;
        top: 50%;
        margin-top: mrem(-6);
        right: urem(16);

        @include on-desktop {
            margin-top: 0;
            top: rem(16);
        }
    }
}

.advise-fade-enter-active {
    transition: all 1.5s ease;
}

.advise-fade-leave-active {
    transition: all 1.5s ease;

    @include on-desktop {
        transition: all 0.5s ease;
    }
}

.advise-fade-enter {
    opacity: 0;
    margin-bottom: -100%;

    @include on-desktop {
        margin-bottom: auto;
        margin-top: -50px;
    }
}

.advise-fade-leave-to {
    opacity: 0;
    margin-bottom: -50%;

    @include on-desktop {
        margin-bottom: auto;
    }
}
</style>
